const search = {
  name: "Name",//名称
  imei:'Imei',//imei
  account: "Account",//账号
  terminalAccount:"Account",//终端账号
  terminalName:"Name",//终端名称
  status: "Status",//状态
  phone: "Phone",//手机号
  group: "Group",//群组
  proxy: "Agent",//代理

  enterprise: "Company",//企业
  subagent: 'Subagent',//子代理
  proxyAnbSubagent:'Agent/Subagent',//代理/子代理
  secondaryManagement: "Department MGT",//二级管理
  onlinestatus: "On/Offline",//在线状态
  createTime: "Create Time",//创建日期
  enableTime: "Start Time",//开始时间
  maturityTime: "Due Time",//到期时间
  modifyTime: "Modify Time",//修改时间
  domainName: "Domain",//域名
  logEventType:'Log Event Type',//操作日志类型,
  operatorAccount:'Operator Account',//操作人账号
  originAccount:'Operation Origin Account',//来源账号
  targetAccount:'Operation Target Account',//目标账号
  targetAccount_1:'被操作人账号',

  orderType: 'Order type',
  orderId:'Order id',


};

export default search;



// WEBPACK FOOTER //
// ./src/api/lang/modules/search/search_en.js